<template>
  <div class="bulk-page" ref="bulkPage" id="bulk-container">
    <div class="top-container">
      <div class="type-container">
        <template v-if="list.length > 0">
          <div
            class="switch-btn"
            style="width: 220px"
            @click="switchType(1)"
            v-show="showDefaultTime"
            :class="{ select: bulkType === 1 }"
          >
            <div class="icon"></div>
            <div class="text">Apply Default Post Time</div>
          </div>
          <div
            @click.stop="switchType(2)"
            class="switch-btn"
            :class="{ select: bulkType === 2 }"
          >
            <div class="icon"></div>
            <div class="text">Apply Bulk Time</div>
          </div>
          <div
            v-if="showDefaultCaption || showDefaultComment"
            class="split"
          ></div>
          <div
            @click.stop="switchApplyDefault(1)"
            v-if="showDefaultCaption"
            class="switch-btn mul"
            :class="{ select: applyDefault.caption }"
          >
            <div class="icon"></div>
            <div class="text">Apply Default Caption</div>
          </div>
          <div
            @click.stop="switchApplyDefault(2)"
            v-if="showDefaultComment && !facebookGroup"
            class="switch-btn mul"
            :class="{ select: applyDefault.comment }"
          >
            <div class="icon"></div>
            <div class="text">Apply Default Comment</div>
          </div>
        </template>
      </div>
      <div class="bulk-form-container" v-if="bulkType === 2">
        <div class="ins-row">
          <div
            class="bulk-form"
            style="height: 24px; margin-top: 22px; margin-bottom: 30px"
          >
            <div class="title">Instagram</div>
            <div class="right-container">
              <ins-list
                type="mul"
                filter="login"
                :disabled="!multiPublisherDistribution"
                :selectIds="applyBulk.publisherIds"
              >
                <div class="user-container">
                  <div
                    class="user-item"
                    v-for="p in publisherList"
                    :key="p.username"
                  >
                    <div
                      class="image"
                      v-lazy:background-image="p.image"
                      :key="p.image"
                    >
                      <div
                        v-if="p.socialNetwork === 1"
                        class="ins-user-icon"
                      ></div>
                      <div
                        v-if="p.socialNetwork === 2"
                        class="fb-page-user-icon"
                      ></div>
                      <div
                        v-if="p.socialNetwork === 3"
                        class="fb-group-user-icon"
                      ></div>
                      <div
                        v-if="p.socialNetwork === 4"
                        class="tw-user-icon"
                      ></div>
                    </div>
                  </div>
                  <div class="add-user-btn" @click="multiPublisherClick"></div>
                </div>
              </ins-list>
            </div>
          </div>
        </div>
        <div class="other-row">
          <div class="bulk-form mask">
            <div class="title">Time Zone</div>
            <div class="right-container">
              <el-select
                v-model="applyBulk.tzName"
                clearable
                filterable
                style="width: 115px"
                placeholder="None"
              >
                <el-option
                  v-for="item in timezones"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="click-icon"></div>
          </div>
          <div class="bulk-form mask">
            <div class="title">Start Time</div>
            <div class="right-container">
              <hi-datetime
                style="width: 125px"
                mask-color="#F5F5F5"
                :clear-able="false"
                v-model="applyBulk.startTime"
                @focus="postTimeFocus"
              ></hi-datetime>
            </div>
            <div class="click-icon"></div>
          </div>
          <div class="bulk-form mask">
            <div class="title">Time Interval</div>
            <div class="right-container">
              <date-interval
                style="width: 125px"
                v-model="applyBulk.interval"
              ></date-interval>
            </div>
            <div class="click-icon"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bulk-info" id="bulk-info">
      <div class="time-list" ref="bulkTimeList">
        <template v-for="time in timeContainer">
          <div v-if="time.title" class="title">{{ time.title }}</div>
          <div class="time-item" :style="{ height: time.height }">
            <div class="empty" v-if="time.index === undefined"></div>
            <bulk-time
              :bulk-type="bulkType"
              v-if="time.index !== undefined"
              :formatTimezone="formatTimezone"
              @confirm="timeChange"
              class="bulk-time"
              :val="timeList[time.index]"
            ></bulk-time>
          </div>
        </template>
      </div>
      <draggable
        id="bulk"
        class="drag-list"
        :class="{ drag: focus !== null && !empty, 'hide-chosen': hideChosen }"
        :options="dragOptions"
        @start="start"
        @end="bulkEnd"
        :move="dragMove"
        v-model="list"
      >
        <bulk-item
          @del="del(item)"
          :info="item"
          :key="item.id"
          v-for="(item, index) in list"
          class="media-item"
          :focus="focus === 'bulk' && hideChosen && replaceIndex === index"
          ref="bulks"
        ></bulk-item>
        <div class="bulk-empty" v-if="empty">
          <div class="upload-icon"></div>
          <div class="upload-btn">
            <span>Drag media from Apphi Library or&nbsp;</span>
            <upload-btn target="#bulk-container" @success="uploadSuccess">
              <span style="text-decoration: underline; cursor: pointer"
                >Upload media from computer</span
              >
            </upload-btn>
          </div>
        </div>
        <div
          v-if="focus === 'bulk' && bulkType === 2 && replaceIndex === -1"
          class="media-item mask empty"
          style="width: 610px; left: -150px"
        ></div>
      </draggable>
    </div>
    <div class="bottom-container" v-if="list.length > 0">
      <hi-button type="text" v-if="text" class="more-btn" @click="addMore"
        >Add More</hi-button
      >
      <hi-button type="primary" class="schedule-btn" @click="scheduleClick"
        >Schedule</hi-button
      >
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import BulkItem from "../../components/media/schedule/bulk/BulkItem";
import _ from "lodash";
import BulkTime from "../../components/media/schedule/bulk/BulkTime";
import { mapGetters } from "vuex";
import {
  CURRENT_PUBLISHER_ID,
  TIMEZONE,
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  BULK_DEFAULT_INFO,
} from "../../store/mutation-types";
import {
  validatePost,
  getDefaultPostTimes,
  formatFormInfo,
} from "../../service/post";
import hiButton from "../../components/button/Index";
import lockr from "lockr";
import { guid, uuid, getTextLength } from "../../utils";
import moment from "moment-timezone";
import { showErrorMsg, initValidate } from "../../utils/errors";
import { permissionValidate, getCaptionComment } from "../../service/publisher";
import uploadBtn from "../../components/library_menu/UploadBtn";
import insList from "../../components/plan_header/ins_list/Index";
import hiDatetime from "../../components/common/form/DateTime";
import { timezones } from "../../const/timezone";
import DateInterval from "../../components/common/DateIntervalSelect";

export default {
  name: "BulkPage",
  components: {
    DateInterval,
    insList,
    hiDatetime,
    hiButton,
    BulkTime,
    BulkItem,
    draggable,
    uploadBtn,
  },
  data() {
    return {
      bulkType: 0,
      uploadMedia: false, // 是否上传media
      replaceIndex: -1, // 如果发现时替换逻辑时，替换的索引位置
      list: [],
      styles: [],
      timezones,
      dateFormat: "MMM DD, YYYY HH:mm",
      dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
      focus: null, // 拖拽的焦点处于哪边 library(左侧) bulk(右侧bulk) null(没有选中)
      hideChosen: false,
      future: {
        relatedIndex: 0,
        index: 0,
        insertAfter: false,
        futureIndex: 0,
      }, // 新添加的bulk的位置
      uploading: false, // 是否正处于上传
      showDefaultTime: false,
      dragOptions: {
        group: { name: "media" },
        handle: ".move-icon",
        forceFallback: true,
        ghostClass: "mask",
        chosenClass: "chosen",
      },
      defaultTime: {}, // default time 对应参数
      applyBulk: {
        publisherIds: [],
        tzName: "",
        startTime: "",
        interval: [0, 1, 0],
      },
      move: {
        drag: false,
        dragId: "",
        dragIndex: 0,
        relatedId: "",
        relatedIndex: 0,
      },
      timeList: [],
      applyDefault: {},
      count: 1, // 专门用于触发computed
    };
  },
  computed: {
    ...mapGetters({
      currentPublisherId: CURRENT_PUBLISHER_ID,
      timezone: TIMEZONE,
      publisher: CURRENT_PUBLISHER_SIMPLE,
      user: CURRENT_USER_INFO_SIMPLE,
      applyDefaultList: BULK_DEFAULT_INFO,
    }),
    // 判断当前选中人是否为Ins账号
    ins() {
      return this.publisher.social_network === 1;
    },
    text() {
      return this.$route.query.bulkType === "text";
    },
    facebookGroup() {
      return this.publisher.socialNetwork === 3;
    },
    twitter() {
      return this.publisher.socialNetwork === 4;
    },
    // 是否显示apply default caption
    showDefaultCaption() {
      return (
        this.publisher.defaultCaption.open && this.publisher.defaultCaption.bulk
      );
    },
    // 是否显示apply default comment
    showDefaultComment() {
      return (
        this.publisher.defaultComment.open && this.publisher.defaultComment.bulk
      );
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    /**
     * 多账号发布权限
     */
    multiPublisherDistribution() {
      return this.permission.multi_publisher_distribution;
    },
    /**
     * tag product权限
     */
    bulkPermission() {
      return this.permission.bulk_schedule_post;
    },
    // 计算当前选中publisher的信息
    publisherList() {
      return this.applyBulk.publisherIds.map((p) => {
        return this.user.linkedInstagramList.find((l) => l.publisherId === p);
      });
    },
    timeEarly() {
      // 如果发现是打开则验证start time 是否早于当前时间，如果早则更新到当前时间+5分钟
      const currentTime = moment();
      const startTime = moment.tz(
        this.applyBulk.startTime,
        this.applyBulk.tzName
      );
      return currentTime.isAfter(startTime);
    },
    /**
     * 计算用于显示的timezone
     */
    formatTimezone() {
      // 获取转换的时区
      let timezone = this.timezone;
      // 如果default time 则设置default time对应时区
      // 如果apply bulk time 则设置对应时区
      if (this.bulkType === 2) {
        timezone = this.applyBulk.tzName;
      } else if (this.bulkType === 1) {
        timezone = this.defaultTime.tzName;
      }
      return timezone;
    },
    // 判断离开是否提示 如果存在一个图片则离开需要提示
    allowLeave() {
      const hasBulk =
        this.list.findIndex((bulk) => bulk.from !== "delete") === -1;
      return hasBulk;
    },
    empty() {
      return this.list.length === 0 && this.focus !== "bulk";
    },
    /**
     * 计算时间
     */
    timeContainer() {
      console.log("count", this.count);
      const timeList = _.cloneDeep(this.timeList);
      if (this.$refs.bulks === undefined) {
        return [];
      }
      timeList.forEach((t, index) => {
        t.index = index;
        const bulkComponent = this.$refs.bulks[index];
        // 如果caption为打开状态则高度为592 为展开为109
        if (bulkComponent && bulkComponent.currentCaption) {
          t.height = `612px`;
        } else {
          t.height = `130px`;
        }
        // 挑选中每天第一个时间
        if (t.postTime) {
          // 获取他的前一天是否和当前是同一天，如果不是同一天则说明他肯定是第一天
          const beforeTime = timeList[index - 1];
          const dateFormat = "MMM DD, YYYY";
          if (beforeTime === undefined) {
            t.title = moment
              .tz(t.postTime, t.tzName)
              .tz(this.formatTimezone)
              .format(dateFormat);
          } else {
            if (
              moment
                .tz(beforeTime.postTime, beforeTime.tzName)
                .tz(this.formatTimezone)
                .format(dateFormat) ===
              moment
                .tz(t.postTime, t.tzName)
                .tz(this.formatTimezone)
                .format(dateFormat)
            ) {
              t.title = "";
            } else {
              t.title = moment
                .tz(t.postTime, t.tzName)
                .tz(this.formatTimezone)
                .format(dateFormat);
            }
          }
        } else {
          t.title = "";
        }
      });
      if (this.focus === "bulk" && this.hideChosen === false) {
        let addIndex = this.future.index;
        if (addIndex === this.list.length) {
          addIndex = timeList.length;
        }
        timeList.splice(addIndex, 0, {
          height: `130px`,
        });
      }
      // 如果有某个时间是隐藏
      return timeList;
    },
    /**
     * 计算是否至少存在一个已设置的时间
     */
    hasOneTime() {
      return this.timeList.findIndex((t) => t.postTime) !== -1;
    },
  },
  watch: {
    currentPublisherId(val, old) {
      if (val) {
        this.resetApplyDefault();
      }
    },
    timeList() {
      this.refreshBulkStyle();
    },
    applyBulk: {
      handler() {
        if (this.bulkType === 2) {
          // 如果当前状态为apply bulk 则每次数据发生变化
          this.timeList = this.updateBulkTime();
        }
      },
      deep: true,
      immediate: true,
    },
    /**
     *
     */
    applyDefault: {
      handler(val, old) {
        if (old.caption === undefined) {
          return;
        }
        const applyDefaultList = _.cloneDeep(this.applyDefaultList);
        // 查看是否能找到对应pulbisher
        // 找到当前publisher对应的bulk信息
        const applyDefault = applyDefaultList.find(
          (apply) => apply.publisherId === this.currentPublisherId
        );
        if (!applyDefault) {
          applyDefaultList.push({
            caption: true,
            comment: true,
            publisherId: this.currentPublisherId,
          });
        } else {
          applyDefault.caption = val.caption;
          applyDefault.comment = val.comment;
          applyDefault.publisherId = this.currentPublisherId;
        }
        this.$store.commit(BULK_DEFAULT_INFO, applyDefaultList);
      },
      deep: true,
    },
    /**
     * 监听时区变化，动态更新post time 和delete time
     */
    "applyBulk.tzName"(val, old) {
      // 初次加载old 为undefined
      if (!old) return;
      if (this.applyBulk.startTime) {
        this.applyBulk.startTime = moment
          .tz(this.applyBulk.startTime, old)
          .tz(val)
          .format(this.dateTimeFormat);
      }
    },
    $route: {
      handler(val, old) {
        if (val.name === "SchedulePage" && val.query.type === "bulk") {
          this.reset();
          // 发现如果是only text模式 则默认添加5个
          if (val.query.bulkType === "text") {
            this.addMore();
            this.addMore();
            this.addMore();
            this.addMore();
            this.addMore();
            this.$nextTick(() => {
              this.count = this.count + 1;
            });
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // only text 模式添加
    addMore() {
      // 超出提示
      if (this.list.length === 20) {
        showErrorMsg(initValidate({ msg: "Max 20 schedules each time." }));
        return;
      }
      let bulkTime = {
        tzName: this.timezone,
        id: guid(),
        createTime: moment(),
        postTime: "",
        deleteTime: "",
      };
      const form = formatFormInfo({});
      form.from = "add";
      form.fromType = "bulk";
      form.id = uuid();
      // 添加一个空表单数据
      this.list.push(form);
      // 同时添加相应元素指定位置到time
      // 如果是default time 和 bulk time模式则根据顺序从新修改post time 时间
      if (this.bulkType === 1) {
        this.timeList.push(bulkTime);
        this.timeList = this.updateDefaultTime();
      } else if (this.bulkType === 2) {
        // 获取添加的bulk 删除之后直接加到末尾
        bulkTime.tzName = this.applyBulk.tzName;
        if (this.timeList.length > 0) {
          const beforeTime = this.timeList[this.timeList.length - 1];
          // 计算发送时间
          const interval = this.applyBulk.interval;
          const uploadIntervalTime =
            interval[1] * 24 * 60 + interval[1] * 60 + interval[2];
          bulkTime.postTime = moment
            .tz(beforeTime.postTime, beforeTime.tzName)
            .add("m", uploadIntervalTime)
            .tz(this.applyBulk.tzName)
            .format("YYYY-MM-DD HH:mm:ss");
        } else {
          bulkTime.postTime = moment
            .tz(this.applyBulk.startTime, this.applyBulk.tzName)
            .format("YYYY-MM-DD HH:mm:ss");
        }
        this.timeList.push(bulkTime);
        // 只有添加才同时滚动到最底部
        const scroller = document.getElementById("bulk-info");
        scroller.scrollTop = 9999;
      } else {
        this.timeList.push(bulkTime);
      }
      this.refreshBulkStyle();
      // 添加新添加bulk的caption 和 comment
      this.setBulkFormCaption(form);
      this.resetAllFormCaptionComment();
    },
    start(m) {
      document.getElementById("app").classList.add("drag");
    },
    bulkEnd() {
      this.move.drag = false;
      document.getElementById("app").classList.remove("drag");
    },
    /**
     * 设置default caption comment
     */
    setBulkFormCaption(item) {
      if (!item) {
        return;
      }
      // 如果相同则说明不是切换的publisher
      const val = this.applyDefault;
      const comment = val.comment;
      const caption = val.caption;
      const params = {
        type: "bulk",
      };
      if (comment) {
        params.comment = item.firstComment;
      } else {
        params.comment = "";
      }
      if (caption) {
        params.caption = item.caption;
      } else {
        params.caption = "";
      }
      const result = getCaptionComment(params);
      if (!item.form.caption && caption) {
        item.form.caption = result.caption;
      }
      if (!item.form.firstComment && comment) {
        item.form.firstComment = result.firstComment;
      }
    },
    /**
     * 重置所有caption 和 first comment
     */
    resetAllFormCaptionComment() {
      this.list.forEach((item) => {
        this.setBulkFormCaption(item);
      });
    },
    /**
     * 多选publisher按钮点击事件
     */
    async multiPublisherClick() {
      // 如果没有权限则弹出对应升级提示
      if (!this.multiPublisherDistribution) {
        await permissionValidate({ type: "basic" });
      }
    },
    /**
     * post time 如果没设置，则自动设置时间
     */
    postTimeFocus() {
      if (!this.applyBulk.startTime) {
        this.applyBulk.startTime = moment()
          .tz(this.applyBulk.tzName)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
    },
    /**
     * 计算当前拖拽转钟相关逻辑
     */
    computedChosen() {
      const relatedIndex = this.future.relatedIndex;
      const addIndex = this.future.index;
      // 此处阻挡的是前后无del情况
      if (
        this.list[relatedIndex] &&
        this.list[relatedIndex].from === "delete"
      ) {
        this.replaceIndex = relatedIndex;
        this.hideChosen = true;
        return;
      }
      if (this.list[addIndex] && this.list[addIndex].from === "delete") {
        this.replaceIndex = -2;
        this.hideChosen = true;
        return;
      }
      if (
        this.list[relatedIndex - 1] &&
        this.list[relatedIndex - 1].from === "delete"
      ) {
        this.replaceIndex = -2;
        this.hideChosen = true;
        return;
      }
      this.hideChosen = false;
      this.replaceIndex = -1;
      // apply bulk time 情况永远隐藏
      if (this.bulkType === 2) {
        this.hideChosen = true;
        return;
      }
      this.hideChosen = false;
    },
    /**
     * 重置apply default 时间
     */
    resetApplyDefault() {
      // 找到当前publisher对应的bulk信息
      const applyDefault = this.applyDefaultList.find(
        (apply) => apply.publisherId === this.currentPublisherId
      );
      if (!applyDefault) {
        this.applyDefault = { caption: true, comment: true };
      } else {
        this.applyDefault = applyDefault;
      }
    },
    /**
     * 重置页面
     */
    reset() {
      this.bulkType = 0;
      this.list = [];
      this.timeList = [];
      // 初始化bulk time的参数
      const startTime = moment()
        .tz(this.timezone)
        .add("m", 5)
        .format("YYYY-MM-DD HH:mm:ss");
      this.applyBulk = {
        publisherIds: [this.currentPublisherId],
        tzName: this.timezone,
        startTime: startTime,
        interval: [0, 1, 0],
      };
      // 获取当前选中用户
      const selectPublisher = this.user.linkedInstagramList.find(
        (link) => link.publisherId === this.publisher.publisherId
      );
      this.showDefaultTime =
        selectPublisher.defaultPostTime &&
        selectPublisher.defaultPostTime.enabled;
      if (this.showDefaultTime) {
        this.defaultTime.tzName = selectPublisher.defaultPostTime.timezone;
      }
      this.resetApplyDefault();
    },
    uploadSuccess(medias) {
      this.list = medias.map((m) => {
        const clone = _.cloneDeep(formatFormInfo({ detail: m }));
        clone.id = guid();
        clone.from = "add";
        return clone;
      });
      this.$nextTick(() => {
        for (let i = 0; i < medias.length; i++) {
          const bulkTime = {
            tzName: this.timezone,
            id: guid(),
            createTime: moment(),
            postTime: "",
            deleteTime: "",
          };
          this.timeList.push(bulkTime);
        }
      });
    },
    /**
     * 重置时间
     */
    clearTime() {
      // 取消的时候清空所有时间
      this.timeList.forEach((t) => {
        t.postTime = "";
        t.deleteTime = "";
        t.tzName = this.timezone;
      });
    },
    /**
     * 更新右侧bulk样式
     */
    refreshBulkStyle() {
      const styles = [];
      this.$nextTick(() => {
        if (!this.$refs.bulkTimeList) {
          return;
        }
        const bulkTimes =
          this.$refs.bulkTimeList.querySelectorAll(".time-item");
        let bulkList = document
          .querySelector("#bulk")
          .querySelectorAll(".media-item");
        bulkList = [...bulkList]
          .map((item) => item)
          .filter((b) => {
            return b.style.display !== "none";
          });
        bulkTimes.forEach((el, index) => {
          // 然后获取每个元素父容器的距顶高度 和 距底高度
          const titleEl = el.previousSibling;
          let margin = 20;
          // 第一个间距特殊 初值为0
          if (index === 0) {
            margin = 0;
          }
          if (titleEl.offsetHeight) {
            margin += Number(titleEl.offsetHeight);
          }
          styles.push({ marginTop: `${margin}px` });
          bulkList[index].style.marginTop = `${margin}px`;
        });
      });
      this.styles = styles;
    },
    dragMove(evt) {
      // 不予许往左侧移动
      if (evt.to.id === "mediaLibrary" || evt.to.id === "saveLibrary") {
        return false;
      }
      this.move = {
        drag: true,
        dragId: evt.draggedContext.element.id,
        dragIndex: evt.draggedContext.index,
        relatedId: evt.relatedContext.element.id,
        relatedIndex: evt.relatedContext.index,
      };
      this.refreshBulkStyle();
      return true;
    },
    // 发送表单
    async scheduleClick() {
      const bulkType = this.bulkType;
      let firstTime;
      try {
        for (let index = 0; index < this.timeList.length; index++) {
          const t = this.timeList[index];
          // 如果存在post time 并且与之对应的from不是删除状态则可以正常发送
          if (t.postTime && this.list[index].from !== "delete") {
            firstTime = {
              postTime: t.postTime,
              deleteTime: t.deleteTime,
              tzName: t.tzName,
            };
            break;
          }
        }
        // 验证是否存在一条有效的发送时间
        if (firstTime === undefined) {
          await Promise.reject(
            initValidate({
              msg: "Please add post time for all your schedules.",
            })
          );
        }
        // 验证第一条发送的时间是否晚于当前时间
        if (moment().isAfter(moment.tz(firstTime.postTime, firstTime.tzName))) {
          await Promise.reject(
            initValidate({
              msg: "Scheduled post time must be greater than current time.",
            })
          );
        }
        // 判断是否有权限
        if (!this.bulkPermission) {
          await permissionValidate({ type: "full" });
          return;
        }
        // 验证当前是否可发送成功
        const postList = [];
        for (let index = 0; index < this.timeList.length; index++) {
          const t = this.timeList[index];
          // 如果存在post time 并且与之对应的from不是删除状态则可以正常发送
          if (t.postTime && this.list[index].from !== "delete") {
            // 查找对应的post 表单
            const form = this.list[index].form;
            // 查找发送人是否已出现在post list中
            form.publisherIds.forEach((publisherId) => {
              const post = postList.find((p) => p.publisherId === publisherId);
              const publisher = this.user.linkedInstagramList.find(
                (p) => p.publisherId === publisherId
              );
              if (post) {
                post.num += 1;
              } else {
                postList.push({
                  publisherId,
                  num: 1,
                  id: publisher.id,
                });
              }
            });
          }
        }
        if (this.twitter) {
          let hasMoreText = false;
          this.list.forEach((item) => {
            const tagNum = getTextLength({ text: item.form.caption });
            if (tagNum > 280) {
              hasMoreText = true;
            }
          });
          if (hasMoreText) {
            const moreText = "Cannot have more than 280 characters on Twitter.";
            await Promise.reject(initValidate({ msg: moreText }));
          }
        } else {
          // 防止ins用户超过2200字符
          if (this.ins) {
            // 验证发送的表单#数量是否超出上限
            let hasMoreText = false;
            this.list.forEach((item) => {
              if (
                getTextLength({
                  text: item.form.firstComment + item.form.caption,
                })
              ) {
                hasMoreText = true;
              }
            });
            if (hasMoreText) {
              const moreText =
                "Cannot have more than 2200 characters on Instagram";
              await Promise.reject(initValidate({ msg: moreText }));
            }
          }
          // 验证发送的表单#数量是否超出上限
          let hasMoreHashTag = false;
          this.list.forEach((item) => {
            const tagNum = [
              ...(item.form.firstComment + item.form.caption),
            ].filter((t) => t === "#").length;
            if (tagNum > 30 && !hasMoreHashTag) {
              hasMoreHashTag = true;
            }
          });
          if (hasMoreHashTag) {
            const moreText =
              "Too many hashtags. Instagram has 30 hashtags limitation.";
            await Promise.reject(initValidate({ msg: moreText }));
          }
        }
        if (postList.length > 0) {
          const success = await validatePost({ postList });
          if (!success) {
            return;
          }
        }
      } catch (e) {
        showErrorMsg(e);
        return;
      }
      // 获取发送时间和form之间的映射
      let forms = [];
      let postTimes = [];
      let loading = this.$loading({
        target: this.$refs.bulkPage,
      });
      try {
        // 只有media模式才验证图片相关
        if (!this.text) {
          const readyList = this.$refs.bulks.map((bulk) => bulk.ready);
          await Promise.all(readyList);
        }
        // 验证图片是否都验证完成
        for (let index = 0; index < this.timeList.length; index++) {
          const t = this.timeList[index];
          // 如果存在post time 并且与之对应的from不是删除状态则可以正常发送
          if (t.postTime && this.list[index].from !== "delete") {
            const postTime = {
              postTime: t.postTime,
              deleteTime: t.deleteTime,
              tzName: t.tzName,
            };
            const repeatTime = [postTime];
            postTimes.push(postTime);
            const mediaList = this.list[index].images;
            const form = _.cloneDeep(this.list[index].form);
            form.tzName = t.tzName;
            form.id = undefined;
            forms.push({ form, mediaList, repeatTime, type: "post" });
          }
        }
        this.$bus.$emit("uploadSchedule", { forms });
        if (bulkType === 1) {
          const defaultTime = lockr.get(`post_${this.currentPublisherId}`, {});
          defaultTime.id = `post_${this.currentPublisherId}`;
          // 重新更新default信息(上次发送时间)
          const lastTime = this.timeList[this.timeList.length - 1];
          defaultTime.sendTime = moment
            .tz(lastTime.postTime, lastTime.tzName)
            .format();
          lockr.set(defaultTime.id, defaultTime);
        }
        this.$toast.show({ message: this.$t("common.success") });
        this.reset();
        // 发现如果是only text模式 则默认添加5个
        if (this.$route.query.bulkType === "text") {
          this.addMore();
          this.addMore();
          this.addMore();
          this.addMore();
          this.addMore();
          this.$nextTick(() => {
            this.count = this.count + 1;
          });
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 事件发生改变 如果不传参数 那只是单纯排序
     */
    timeChange(time) {
      if (time) {
        // 如果处于自定义模式则根据time重新排序
        const changeIndex = this.timeList.findIndex((t) => t.id === time.id);
        this.$set(this.timeList, changeIndex, time);
      }
      // 获取时间和右侧form的映射关系
      const map = [];
      this.timeList.forEach((t, index) => {
        map.push({
          timeId: t.id,
          formId: this.list[index].id,
        });
      });
      // 然后从新根据post time 排序
      const timeList = this.timeList.sort((t1, t2) => {
        // 事件不存在则排到最后
        if (!t1.postTime) {
          return 1;
        }
        if (
          moment
            .tz(t1.postTime, t1.tzName)
            .tz(this.timezone)
            .format(this.dateFormat) ===
          moment
            .tz(t2.postTime, t2.tzName)
            .tz(this.timezone)
            .format(this.dateFormat)
        ) {
          return moment(t1.createTime).isAfter(t2.createTime) ? 1 : -1;
        }
        return moment
          .tz(t1.postTime, t1.tzName)
          .isAfter(moment.tz(t2.postTime, t2.tzName))
          ? 1
          : -1;
      });
      this.$set(this, "timeList", timeList);
      // 然后调整form 顺序
      const list = timeList.map((t) => {
        const formId = map.find((m) => m.timeId === t.id).formId;
        return this.list.find((item) => item.id === formId);
      });
      this.$set(this, "list", list);
    },
    del(item) {
      // 如果删除的default time 则直接删除对应项
      if (this.bulkType === 1 || this.text) {
        const delIndex = this.list.findIndex((i) => i.id === item.id);
        this.list.splice(delIndex, 1);
        this.timeList.splice(delIndex, 1);
        if (this.bulkType === 1) {
          this.$set(this, "timeList", this.updateDefaultTime(true));
        }
      }
      // 将状态变成delete
      item.from = "delete";
      // 当删除的时候判断bulk是否全部删除，且时间都清除
      const hasNoBulk =
        this.list.findIndex((bulk) => bulk.from !== "delete") === -1;
      const hasNoBulkTime = this.timeList.findIndex((t) => t.postTime) === -1;
      if (hasNoBulk && hasNoBulkTime) {
        this.list = [];
        this.timeList = [];
      }
      this.refreshBulkStyle();
    },
    async switchApplyDefault(type) {
      if (type === 1) {
        // 如果caption等于true 说明在改就是否 需要删除之前的caption 给出提示
        if (this.applyDefault.caption) {
          const msg = "Turn off Default Caption will delete all captions.";
          await this.$confirm.show({
            text: msg,
            yesText: "Delete",
            cancelText: "Cancel",
          });
          this.list.forEach((item) => {
            item.form.caption = "";
          });
        }
        this.applyDefault.caption = !this.applyDefault.caption;
      } else {
        // 如果comment等于true 说明在改就是否 需要删除之前的comment 给出提示
        if (this.applyDefault.comment) {
          const msg = "Turn off Default Comment will delete all comments.";
          await this.$confirm.show({
            text: msg,
            yesText: "Delete",
            cancelText: "Cancel",
          });
          this.list.forEach((item) => {
            item.form.firstComment = "";
          });
        }
        this.applyDefault.comment = !this.applyDefault.comment;
      }
      this.resetAllFormCaptionComment();
    },
    /**
     * 切换bulk类型
     * @param type
     */
    async switchType(type) {
      if (type === this.bulkType) {
        this.bulkType = 0;
        this.clearTime();
      } else {
        if (this.hasOneTime) {
          let msg = ``;
          if (type === 2) {
            msg = `Apply bulk time to all your schedules?`;
          } else if (type === 1) {
            msg = `Apply default post time to all your schedules?`;
          }
          await this.$confirm.show({
            text: msg,
            yesText: "Yes",
            cancelText: "No",
          });
        }
        this.bulkType = type;
        if (type === 1) {
          this.bulkType = 1;
          this.$set(this, "timeList", this.updateDefaultTime(true));
        } else if (type === 2) {
          // 初始化bulk time的参数
          const startTime = moment()
            .tz(this.timezone)
            .add("m", 5)
            .format("YYYY-MM-DD HH:mm:ss");
          this.applyBulk = {
            publisherIds: [this.currentPublisherId],
            tzName: this.timezone,
            startTime: startTime,
            interval: [0, 1, 0],
          };
          this.timeList = this.updateBulkTime();
        }
      }
      this.refreshBulkStyle();
    },
    updateDefaultTime(clear = false) {
      // 切换default time 之前去掉无效的bulk
      const delList = _.cloneDeep(this.list.filter((i) => i.from === "delete"));
      delList.forEach((del) => {
        // 找到待删除索引
        const delIndex = this.list.findIndex((i) => i.id === del.id);
        this.list.splice(delIndex, 1);
        this.timeList.splice(delIndex, 1);
      });
      // 获取最近20条default time
      const times = getDefaultPostTimes({
        type: "post",
        publisherId: this.currentPublisherId,
      });
      const timeList = this.timeList.map((time, index) => {
        const result = {};
        result.tzName = this.timezone;
        result.id = time.id;
        result.createTime = time.createTime;
        result.postTime = times[index]
          .tz(this.timezone)
          .format("YYYY-MM-DD HH:mm:ss");
        result.deleteTime = "";
        if (clear) {
          result.deleteTime = "";
        } else {
          result.deleteTime = time.deleteTime;
        }
        return result;
      });
      return timeList;
    },
    updateBulkTime() {
      const timeList = this.timeList.map((time, index) => {
        const result = {};
        result.tzName = this.applyBulk.tzName;
        result.id = time.id;
        result.createTime = time.createTime;
        // 计算发送时间
        const interval = this.applyBulk.interval;
        const uploadIntervalTime =
          interval[0] * 24 * 60 + interval[1] * 60 + interval[2];
        const postTime = moment(this.applyBulk.startTime).add(
          "m",
          index * uploadIntervalTime
        );
        result.postTime = postTime.format("YYYY-MM-DD HH:mm:ss");
        result.deleteTime = "";
        return result;
      });
      // 修改publsiher
      this.list.forEach((item) => {
        item.form.publisherIds = _.cloneDeep(this.applyBulk.publisherIds);
      });
      return timeList;
    },
  },
  created() {
    this.reset();
    this.$bus.$on("dragStart", () => {
      this.focus = "library";
      this.computedChosen();
    });
    this.$bus.$on("dragEnd", (data) => {
      this.focus = null;
      // 获取新添加元素的位置
      const newIndex = data.newIndex;
      let bulkTime = {
        tzName: this.timezone,
        id: guid(),
        createTime: moment(),
        postTime: "",
        deleteTime: "",
      };
      // 非指向bulk的不计数
      if (data.to.id !== "bulk") {
        return;
      }
      // 如果添加的位置原来是被移除的项则替代原form
      if (this.replaceIndex > -1) {
        // 判断替换的是否为del
        if (this.list[this.replaceIndex].from === "delete") {
          this.list.splice(this.replaceIndex, 1);
        } else {
          this.list.splice(this.replaceIndex + 1, 1);
        }
      } else if (this.replaceIndex === -2) {
        // 这种情况不能添加则直接删除
        this.list.splice(newIndex, 1);
      } else {
        if (this.bulkType === 2) {
          // 获取添加的bulk 删除之后直接加到末尾
          this.list.push(this.list[newIndex]);
          this.list.splice(newIndex, 1);
          bulkTime.tzName = this.applyBulk.tzName;
          if (this.timeList.length > 0) {
            const beforeTime = this.timeList[this.timeList.length - 1];
            // 计算发送时间
            const interval = this.applyBulk.interval;
            const uploadIntervalTime =
              interval[1] * 24 * 60 + interval[1] * 60 + interval[2];
            bulkTime.postTime = moment
              .tz(beforeTime.postTime, beforeTime.tzName)
              .add("m", uploadIntervalTime)
              .tz(this.applyBulk.tzName)
              .format("YYYY-MM-DD HH:mm:ss");
          } else {
            bulkTime.postTime = moment
              .tz(this.applyBulk.startTime, this.applyBulk.tzName)
              .format("YYYY-MM-DD HH:mm:ss");
          }
          this.timeList.push(bulkTime);
          // 只有添加才同时滚动到最底部
          const scroller = document.getElementById("bulk-info");
          scroller.scrollTop = 9999;
        } else {
          // 同时添加相应元素指定位置到time
          this.timeList.splice(newIndex, 0, bulkTime);
        }
      }
      // 判断如果超出上限则提示不允许添加
      if (this.list.length > 21) {
        this.list.splice(newIndex, 1);
        this.timeList.splice(newIndex, 1);
        showErrorMsg(initValidate({ msg: "Max 20 schedules each time." }));
        return;
      }
      // 如果是default time 和 bulk time模式则根据顺序从新修改post time 时间
      if (this.bulkType === 1) {
        this.timeList = this.updateDefaultTime();
      }
      this.refreshBulkStyle();
      // 添加新添加bulk的caption 和 comment
      this.setBulkFormCaption(this.list[newIndex]);
      this.resetAllFormCaptionComment();
    });
    this.$bus.$on("dragMove", (data) => {
      if (data.to.id === "bulk") {
        this.focus = "bulk";
      } else if (data.to.id === "saveLibrary") {
        this.focus = "library";
      } else if (data.to.id === "mediaLibrary") {
        this.focus = "library";
      }
      let futureIndex = data.relatedContext.index;
      if (data.willInsertAfter === undefined) {
        futureIndex = this.list.length;
      }
      if (data.willInsertAfter) {
        futureIndex += 1;
      }
      // 如果 data.relatedContext.index 不存在说明是最后一个
      let relatedIndex = data.relatedContext.index;
      if (relatedIndex === undefined) {
        relatedIndex = this.list.length - 1;
      }
      this.future = {
        relatedIndex,
        insertAfter: !!data.willInsertAfter,
        index: futureIndex,
        futureIndex: data.draggedContext.futureIndex,
      };
      this.computedChosen();
    });
  },
};
</script>
<style lang="less">
.bulk-page {
  display: flex;
  flex-direction: column;

  .drag-list {
    &.hide-chosen .media-item.sortable-chosen {
      height: 0 !important;
      min-height: auto;
      margin-bottom: 0;
    }

    .media-item {
      margin-bottom: 20px;
      min-height: 110px;

      .num-text,
      .duration,
      .media-info {
        display: none;
      }

      &.mask {
        background: rgb(220, 220, 220) !important;
        border-radius: 4px;
        border: dashed 1px #d2d2d2;

        .main-container {
          display: none;
        }

        .operation-container {
          display: none;
        }
      }

      &.empty {
        /*width: 610px;*/
        /*left: -150px;*/
        position: relative;
      }

      &.sortable-chosen {
        background: rgb(220, 220, 220) !important;

        .main-container {
          display: none;
        }

        .operation-container {
          display: none;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "../../assets/style/theme.less";

.split {
  height: 25px;
  width: 1px;
  background: @border-color;
  margin: 0 20px 0 0;
}

.bulk-page {
  flex: 1;
  background: #fafafa;
  overflow: auto;

  .top-container {
    background: white;
    border-bottom: 1px solid #eceff1;
    padding: 7px 40px;
    min-height: 50px;

    .type-container {
      display: flex;
      align-items: center;
      position: relative;

      .switch-btn {
        width: 210px;
        height: 36px;
        border-radius: 6px;
        border: solid 1px #e6e6e6;
        font-size: 14px;
        display: flex;
        align-items: center;
        margin-right: 20px;
        padding: 0 10px;
        cursor: pointer;
        &.mul.select {
          .icon {
            background-image: url(../../../public/images/common/checkbox_checked_select@3x.png);
          }
        }
        &.select {
          border-color: @theme-color;
          color: @theme-color;

          .icon {
            background-image: url(../../../public/images/bulk/checkbox_checked_disable@3x.png);
          }

          .right-icon {
            background-image: url(../../../public/images/bulk/Rectangle_red_1@3x.png);
          }
        }

        &.open {
          .right-icon {
            background-image: url(../../../public/images/bulk/Rectangle_gray_2@3x.png);
          }

          &.select .right-icon {
            background-image: url(../../../public/images/bulk/Rectangle_red_2@3x.png);
          }
        }

        .icon {
          width: 16px;
          height: 16px;
          background-image: url(../../../public/images/bulk/checkbox_checked_able@3x.png);
          background-size: contain;
          cursor: pointer;

          &:hover,
          &:active {
            opacity: 0.3;
          }
        }

        .text {
          margin-left: 10px;
          font-weight: 500;
          line-height: 1;
          flex: 1;
        }

        .right-icon {
          width: 12px;
          height: 12px;
          background-image: url(../../../public/images/bulk/Rectangle_gray_1@3x.png);
          background-size: contain;
        }
      }
    }
    .form-item {
      display: flex;
      height: 44px;
      align-items: center;
      &.caption-repost {
        height: 60px;
        .icon {
          position: relative;
          bottom: 9px;
        }
        .right {
          position: relative;
          bottom: 9px;
        }
      }

      .title {
        text-transform: capitalize;
        margin-right: 20px;
        width: 200px;
        .form-tip {
          text-transform: none;
          color: #8c8c8c;
          font-size: 14px;
          margin-top: 6px;
        }
      }

      .right {
        flex: 1;
        display: flex;
      }
    }
  }

  .bulk-info {
    display: flex;
    position: relative;
    padding: 20px 40px 20px 40px;
    flex: 1;
    overflow: auto;

    .drag-container {
      z-index: 2;
      display: flex;
    }

    .bulk-empty {
      z-index: 1;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .upload-icon {
        width: 100px;
        height: 100px;
        background-image: url(../../../public/images/bulk/upload@3x.png);
        background-size: contain;
      }

      .upload-btn {
        width: 600px;
        height: 66px;
        background-size: contain;
        background-image: url("../../../public/images/bulk/border.png");
        color: rgb(140, 140, 140);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 80px;
      }
    }

    .time-list {
      width: 145px;
      height: 100%;

      .title {
        height: 40px;
        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
      }

      .time-item {
        height: 80px;
        width: 100%;

        .empty {
          background: rgb(220, 220, 220);
          height: 110px;
        }
      }
    }

    .drag-list {
      min-height: 100%;

      &.drag {
        position: absolute;
        padding-left: 145px;
        width: 617px;
        left: 40px;
      }
    }
  }

  .bottom-container {
    height: 64px;
    display: flex;
    align-items: center;
    padding: 0 40px;
    width: 680px;
    justify-content: flex-end;

    .more-btn {
      width: 135px;
      height: 36px;
      border: 1px solid @theme-color;
      margin-right: 20px;
    }

    .schedule-btn {
      width: 150px;
      height: 36px;
    }
  }

  .bulk-form-container {
    .ins-row {
      padding-left: 10px;
    }

    .other-row {
      display: flex;
      padding-bottom: 20px;
    }
  }

  .bulk-form {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px !important;
    margin-right: 40px;

    &.mask {
      height: 36px;
      border-radius: 3px;
      background: #f5f5f5;
      padding: 0 10px;
    }

    .title {
      font-size: 13px;
      font-weight: 500;
    }

    .right-container {
      flex: 1;
      display: flex;
      margin-left: 10px;

      .user-container {
        flex: 1;
        align-items: center;
        overflow-x: auto;
        display: flex;
        cursor: pointer;
        width: 160px;
        margin-left: 10px;

        .add-user-btn {
          height: 24px;
          width: 24px;
          background-size: contain;
          background-image: url("../../../public/images/bulk/add_gray@3x.png");

          &:hover {
            background-image: url("../../../public/images/bulk/add_red@3x.png");
          }
        }

        .user-item {
          display: flex;
          align-items: center;
          margin-right: 10px;

          .image {
            height: 24px;
            width: 24px;
            border-radius: 50%;
            background-size: contain;
            background-position: center;
            position: relative;
          }
        }
      }
    }

    .click-icon {
      width: 12px;
      height: 12px;
      background-image: url("../../../public/images/bulk/Rectangle_gray_1@3x.png");
      background-size: contain;
      margin-left: 5px;
      position: relative;
      top: 1px;
    }
  }
}
</style>
